export function isEmpty(v) {
  return v == null || typeof v == 'undefined' || (typeof v == 'string' && v.trim() == '') || (typeof v == 'object' && v.length == 0)
}
/**
 * 
 * @description 根据树中键值找到第一个符合要求的对象
 * @param {*} data 树型数组
 * @param {*} key String 对象中的key值
 * @param {*} value key值符合的条件
 * @returns result 符合条件的首个节点
 */
export function getFirstChidlren(data, key, value) {
    let result = null;
    let fn = function (d) {
      if (Array.isArray(d)) { // 判断是否是数组
          for (let i = 0; i < d.length; i++) {
            const e = d[i];
            if (e[key] === value) { // 数据循环每个子项，并且判断子项下边是否有id值
                result = e; // 返回的结果等于每一项
                break;
            } else if (e.children) {
                fn(e.children); // 递归调用下边的子项
            }
          }
      }
  }
  fn(data); // 调用一下
  return result;
}

/**
 * 
 * @description 根据树中键值找到该id的所有父元素id
 * @param {*} tree 树型数组
 * @param {*} nodeId 节点id
 * @param {*} config 节点信息配置config。config用于配置id和children字段；
 * @returns result 
 */
export function getTreeIds (tree, nodeId, config) {
  const { children = 'children', id = 'id' } = config || {}
  const toFlatArray = (tree, parentId) => {
    return tree.reduce((t, _) => {
      const child = _[children]
      return [
        ...t,
        parentId ? { ..._, parentId } : _,
        ...(child && child.length ? toFlatArray(child, _[id]) : [])]
    }, [])
  }
  const getIds = flatArray => {
    let ids = [nodeId]
    let child = flatArray.find(_ => _[id] === nodeId)
    while (child && child.parentId) {
      ids = [child.parentId, ...ids]
      child = flatArray.find(_ => _[id] === child.parentId)
    }
    return ids
  }
  return getIds(toFlatArray(tree))
}

//查找树结构中某个字段 返回所有值等于或包含targetValue的node和它的父级的集合
export function findCollectionByValFromTree(tree, key, targetValue, type) {
  //如果targetValue为空值 直接逻辑短路
  if (_.isString(targetValue) && targetValue.trim() == '') {
    return []
  }
  let collection = [];
  //辅助函数
  function findCollectionHelper(node, pnode = [], key, targetValue) {
    //如果[父级以上元素栈]为空 那么将当前节点填入空栈中 供递归后置节点使用
    if (_.isArray(pnode) && _.isEmpty(pnode)) {
      pnode = [node]
    } else {
      //如果[父级以上元素栈]为非空 将当前元素插入栈顶
      pnode = [node, ...pnode]
    }

    //根据type做对应操作
    switch (type) {
      case 'equal':
        if (node[key] == targetValue) {
          collection = [...collection, ...pnode]
        }
        break
      case 'contain':
        if (node[key].indexOf(targetValue) > -1) {
          collection = [...collection, ...pnode]
        }
        break
    }
    //判断是否有子集
    if (_.isArray(node.children) && !_.isEmpty(node.children)) {
      node.children.forEach((item) => {
        findCollectionHelper(item, pnode, key, targetValue);
      });
    }
  }
  if (_.isArray(tree) && !_.isEmpty(tree)) {
    tree.forEach((item) => {
      findCollectionHelper(item, [], key, targetValue);
    });
  } else if (_.isArray(tree.children) && !_.isEmpty(tree.children)) {
    tree.children.forEach((item) => {
      findCollectionHelper(item, [], key, targetValue);
    });
  }
  return collection;
}

//查找树结构 审查每个节点 如果该节点没有目标字段 就插入目标字段和对应的目标值 最后返回处理后的tree
export function insertAttrToEveryNode(tree, valMap) {
  //辅助函数
  function insertAttrHelper(node, valMap) {

    Object.keys(valMap).forEach(item => {
      if (_.isNull(node[item]) || _.isUndefined(node[item])) {
        node[item] = valMap[item]
      }
    })


    if (isArray(node.children)) {
      node.children.forEach((item) => {
        insertAttrHelper(item, valMap);
      });
    }
  }

  if (isArray(tree)) {
    tree.forEach((item) => {
      insertAttrHelper(item, valMap);
    });
    return tree
  } else if (isArray(tree.children)) {
    tree.children.forEach((item) => {
      insertAttrHelper(item, valMap);
    });
    return tree
  }
}

export function isArray(v) {
  return v && Object.prototype.toString.call(v) == "[object Array]"
}

// ai数据格式化
export function formatArray(originalArray) {
  return originalArray.map(item => {
      const validField = Object.entries(item).find(([key, value]) => value !== null);
      
      if (!validField) return null;
      
      const [fieldType, fieldData] = validField;
      
      // 创建一个新对象，使用 fieldType 作为字段类型
      return {
          fieldType: fieldType, // 使用 fieldType 而不是 type
          ...fieldData
      };
  }).filter(Boolean);
}

export function formatRules(originalArray) {
  let rules = {};
  
  originalArray.forEach(item => {
    // 找到第一个非null的字段类型
    const fieldTypes = ['textInput', 'number', 'checkbox', 'paragraph', 'select', 'fileList', 'file'];
    let fieldType = null;
    let fieldData = null;
    
    for (const type of fieldTypes) {
      if (item[type] !== null) {
        fieldType = type;
        fieldData = item[type];
        break;
      }
    }
    
    // 如果找到了字段数据且required为true
    if (fieldData && fieldData.required && fieldData.variable) {
      rules[fieldData.variable] = {
        required: true,
        message: `${fieldData.label || fieldData.variable}是必填项！`,
      };
    }
  });
  
  return rules;
}

export function formatDatas(originalArray) {
  let datas = {};
  
  originalArray.forEach(item => {
    // 找到第一个非null的字段类型
    const fieldTypes = ['textInput', 'number', 'checkbox', 'paragraph', 'select', 'fileList', 'file'];
    
    for (const type of fieldTypes) {
      if (item[type] !== null && item[type].variable) {
        // 使用defaultValue如果存在，否则使用空字符串
        datas[item[type].variable] = item[type].defaultValue !== undefined ? item[type].defaultValue : '';
        break; // 找到第一个有效字段后就跳出循环
      }
    }
  });
  
  return datas;
}

export function floatTo16BitPCM(float32Array) {
  const buffer = new ArrayBuffer(float32Array.length * 2);
  const data = new DataView(buffer);

  for (let i = 0; i < float32Array.length; i++) {
    let s = Math.max(-1, Math.min(1, float32Array[i]));
    data.setInt16(i * 2, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
  }
  return buffer;
}

export function generateBrowserUserId() {
  const key = 'dify_chat_user_id';
  let userId = localStorage.getItem(key);

  if (!userId) {
    // 生成唯一ID：时间戳 + 随机数 + 浏览器指纹
    const timestamp = Date.now();
    const random = Math.random().toString(36).substr(2, 9);
    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
    ].join('|');

    // 创建简单的hash
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // 转换为32位整数
    }

    userId = `user_${timestamp}_${random}_${Math.abs(hash).toString(36)}`;
    localStorage.setItem(key, userId);
  }

  return userId;
}